import Clusters from 'baas-ui/services/mongodb/clusters/Clusters';

import App from './App';
import Services from './Services';

export default { App, Services, Clusters };
